import React from "react";
import { InputAdornment, InputProps } from "@material-ui/core";
import { Text, TextProps } from "./Text";

type Props = TextProps & {
  currency?: string; // kr. by default
  InputProps?: InputProps;
};

export function CurrencyText(props: Props) {
  const { currency = "kr.", TextFieldProps = {}, InputProps = {} } = props;

  const { fullWidth } = TextFieldProps;

  const myInputProps = {
    endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
    type: "number",
    inputProps: {
      style: { textAlign: "right" } as React.CSSProperties
    },
    style: { width: fullWidth ? undefined : 90 } as React.CSSProperties,
    ...InputProps
  };

  // const _InputProps = merge(myInputProps, InputProps);

  return (
    <Text {...props} TextFieldProps={{ ...TextFieldProps, InputProps: myInputProps }} />
  );
}
